import React from 'react';
import { Route, Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import RegisterDriver from '../driver/auth/RegisterDriver';
import UploadCnic from '../driver/auth/UploadCnic';
import DriverLogin from '../driver/auth/DriverLogin';
import PhoneVerify from '../driver/auth/PhoneVerify';
import PotentialBookingsLocal from '../driver/local/PotentialBookingsLocal';
import PotentialBookingDetails from '../driver/local/PotentialBookingDetails';
import DriverMyBookings from '../driver/displayBooking/DriverMyBookings';
import ProtectedRoute from "../auth/ProtectedRoute";
import ComingSoon from '../layout/ComingSoon';
import Payment from '../driver/payment/Payment';

const DriverRoutes = () => {
  
  const accountStatus = useSelector((state) => state.auth.user?.accountStatus); // Adjust according to your Redux state structure

  return (
    <>
      <Route path="/driver/register" element={<RegisterDriver />} />
      <Route path="/driver/login" element={<DriverLogin />} />
      <Route path="/driver/verify-phone" element={<PhoneVerify />} />

      <Route path="/coming-soon" element={<ComingSoon />} />

      {/* Restrict access to UploadCnic if accountStatus is 'active' */}
      <Route 
      path="/driver/upload-cnic"
      element={accountStatus === 'Active' || accountStatus === 'Suspended' ? <Navigate to="/" /> : 
      <ProtectedRoute driver={true}>
      <UploadCnic />
      </ProtectedRoute>
      }
      />

      <Route 
      path="/driver/potential-local-bookings"  
      element={
        <ProtectedRoute driver={true}>
        <PotentialBookingsLocal />
        </ProtectedRoute>
        } 
      />

     <Route 
      path="/driver/bookings/:id"
      element={
        <ProtectedRoute driver={true}>
        <PotentialBookingDetails />
        </ProtectedRoute>
        } 
      />

      <Route 
      path="/driver/mybookings"  
      element={
        <ProtectedRoute driver={true}>
        <DriverMyBookings />
        </ProtectedRoute>
        } 
      />


      <Route 
      path="/driver/payment"  
      element={
        <ProtectedRoute driver={true}>
        <Payment />
        </ProtectedRoute>
        } 
      />
      
    </>
  );
};

export default DriverRoutes;
